<template>
  <div class="step-section">
    <div class="selected-doctor-card" v-if="selectedDoctor">
      <img
        :src="selectedDoctor.image_url"
        :alt="selectedDoctor.name"
        class="doctor-image"
      />
      <div class="doctor-copy">
        <h5>{{ selectedDoctor.name }}</h5>
        <h6>{{ selectedSpeciality }}</h6>
      </div>
    </div>

    <div class="step-container">
      <h2 class="step-title">
        {{ $store.state.bookingSteps.stepsData.step3.title }}
      </h2>

      <div class="calendar-layout">
        <div class="calendar-panel">
          <allowed-dates @input="getTimes" />
        </div>

        <div class="times-panel">
          <div v-if="loading" class="loading-state">
            <div class="spinner"></div>
          </div>

          <allowed-times
            v-else
            :available-slots="allowedTimesSlots"
            :selected-date="selectedDate"
            @changeTime="selectedTime = $event"
          />
        </div>
      </div>
    </div>

    <steps-nav
      :cancel-button-label="
        $store.state.bookingSteps.stepsData.cancelButtonLabel
      "
      :next-button-label="
        $store.state.bookingSteps.stepsData.bookingButtonLabel
      "
      :can-proceed="Boolean(selectedDate && selectedTime)"
      @cancel="$emit('cancel')"
      @next="book"
    />
  </div>
</template>

<script>
import allowedDates from "./allowedDates";
import allowedTimes from "./allowedTimes";
import API from "@/api/dynamicAPI";
import moment from "moment";
import StepsNav from "../StepsNav";
export default {
  name: "step3",
  components: {
    allowedTimes,
    allowedDates,
    StepsNav,
  },
  data() {
    return {
      allowedTimesSlots: [],
      loading: false,
      selectedDate: null,
      selectedTime: null,
    };
  },
  methods: {
    async getTimes(date) {
      this.allowedTimesSlots = [];
      this.selectedDate = date;
      this.selectedTime = null;
      try {
        this.loading = true;
        const stepData = this.$store.state.bookingSteps.stepsData;
        const extraAttributes = {
          specialty_id: this.$store.state.bookingSteps.selectedStepsData[
            stepData.step1.selectedIdAttribute
          ],
          clinic_code: this.$store.state.bookingSteps.selectedStepsData[
            stepData.step2.selectedCodeAttribute
          ],
          doctor_id: this.$store.state.bookingSteps.selectedStepsData[
            stepData.step2.selectedIdAttribute
          ],
          date,
        };
        let res = null;
        if (stepData.step3.request.type === "get") {
          res = await API.getAPI(
            stepData.step3.request,
            stepData.step3.request.headers,
            extraAttributes
          );
        } else if (stepData.step3.request.type === "post") {
          res = await API.postAPI(
            stepData.step3.request,
            stepData.step3.request.headers,
            extraAttributes
          );
        }
        if (res && res.data && res.data.length) {
          this.allowedTimesSlots = res.data[0].availableSlots;
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    book() {
      if (!this.selectedDate || !this.selectedTime) return;

      this.$store.state.bookingSteps.selectedStepsData[
        this.$store.state.bookingSteps.stepsData.step3.selectedDateAttribute
      ] = this.selectedDate;
      this.$store.state.bookingSteps.selectedStepsData[
        this.$store.state.bookingSteps.stepsData.step3.selectedTimeAttribute
      ] = this.selectedTime;
      this.$store.state.bookingSteps.selectedStepsData[
        this.$store.state.bookingSteps.stepsData.step3.selectedWorkDayAttribute
      ] = this.$t(`weekDays.${moment(this.selectedDate).isoWeekday()}`);
      this.$emit("submitBooking");
    },
  },
  computed: {
    selectedDoctor() {
      if (this.$store.state.bookingSteps.selectedDoctor) {
        return this.$store.state.bookingSteps.selectedDoctor;
      }

      return this.$store.state.bookingSteps.doctors.find((doctor) => {
        return (
          doctor.id ===
          this.$store.state.bookingSteps.selectedStepsData[
            this.$store.state.bookingSteps.stepsData.step2.selectedIdAttribute
          ]
        );
      });
    },
    selectedSpeciality() {
      return this.$store.state.bookingSteps.selectedStepsData[
        this.$store.state.bookingSteps.stepsData.step1.selectedNameAttribute
      ];
    },
  },
};
</script>

<style scoped lang="scss">
.step-section {
  padding-bottom: 12px;
  overflow-x: hidden;
}

.selected-doctor-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 28px 18px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.16);
  min-width: 0;
}

.doctor-image {
  width: 76px;
  height: 76px;
  border-radius: 22px;
  object-fit: cover;
  background: #f8fafc;
}

.doctor-copy h5 {
  margin: 0 0 8px;
  color: var(--main-color);
  font-size: 18px;
  font-weight: 800;
  word-break: break-word;
}

.doctor-copy h6 {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
  word-break: break-word;
}

.step-container {
  padding: 18px 28px 0;
  width: 100%;
  min-width: 0;
  overflow-x: hidden;
}

.step-title {
  margin-bottom: 18px;
  color: var(--main-color);
  font-size: 24px;
  font-weight: 800;
  line-height: 1.2;
}

.calendar-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(320px, 0.8fr);
  gap: 18px;
  align-items: stretch;
  width: 100%;
  min-width: 0;
}

.calendar-panel,
.times-panel {
  min-width: 0;
  width: 100%;
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 26px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.05);
}

.times-panel {
  min-height: 440px;
}

.loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 440px;
}

.spinner {
  width: 52px;
  height: 52px;
  border: 4px solid rgba(148, 163, 184, 0.24);
  border-top-color: var(--main-color);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 959px) {
  .selected-doctor-card {
    padding: 8px 16px 16px;
  }

  .step-container {
    padding: 16px 16px 0;
  }

  .step-title {
    font-size: 20px;
  }

  .calendar-layout {
    grid-template-columns: 1fr;
  }

  .times-panel,
  .loading-state {
    min-height: 280px;
  }
}
</style>
